import { dehydrate } from '@tanstack/react-query'

import Home from 'src/components/pages/Home'
import { fetchPageData } from 'src/lib/react-query/api'
import { getQueryClient } from 'src/lib/react-query/client'
import { getHeaderDataQuery, queryKeys } from 'src/lib/react-query/queries'
import { withSSRCorrelation } from 'src/lib/withSSRCorrelation'
import { type HeaderData } from 'src/components/navigation/header/headerHelpers'
import { parseErrorToServerFunction } from 'src/lib/api'

import type { GetServerSideProps } from 'next'
import type { JsonApiCmsHomePage } from 'src/types/adsales/models/cmsPages'

const HomePage = ({ res, headerData }: { res: JsonApiCmsHomePage; headerData: HeaderData }) => (
  <Home res={res} headerData={headerData} />
)

export default HomePage

export const getServerSideProps: GetServerSideProps = withSSRCorrelation(async () => {
  const slug = 'home'
  const queryClient = getQueryClient()

  await queryClient.prefetchQuery({
    queryKey: queryKeys.menu,
    queryFn: getHeaderDataQuery
  })

  const headerData = queryClient.getQueryData(queryKeys.menu)
  const { data, isError, error } = await fetchPageData<JsonApiCmsHomePage>(slug)

  if (isError && error) {
    return parseErrorToServerFunction(error)
  }

  return {
    props: {
      res: data,
      slug,
      headerData,
      dehydratedState: dehydrate(queryClient)
    }
  }
})
